import React, { useState } from "react";

import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

import UnoSolid from "UI/images/UnoSolid";

// Uno jumps and flips for joy that the text was copied to the clipboard

const variants = {
  unsaved: {
    translateY: 0,
  },

  success: {
    translateY: [0, 4, 0],
    transition: {
      type: "tween",
      duration: 0.2,
      delay: 1.3,
    },
  },
  error: {
    rotate: [0, 10, -10, 10, -10, 10, 0],
    transition: { duration: 0.3 },
  },
};

export default function CopyToClipboard({ text, size }) {
  const [animationState, setAnimationState] = useState("unsaved"); // unsaved, success, error
  const [isSaved, setIsSaved] = useState(false);
  const [isError, setIsError] = useState(false);
  const [solidIcon, setSolidIcon] = useState(false);
  const [showUno, setShowUno] = useState(false);

  async function handleClick() {
    try {
      await navigator.clipboard.writeText(text);
      setAnimationState("success");
      setShowUno(true);
      setTimeout(() => {
        setSolidIcon(true);
        setIsSaved(true);
      }, 1500);
      setTimeout(() => {
        setIsSaved(false);
        setAnimationState("unsaved");
      }, 3500);
      setTimeout(() => {
        setSolidIcon(false);
      }, 3700);
    } catch (err) {
      console.log(err);
      setAnimationState("error");
      setIsError(true);
      setTimeout(() => {
        setIsError(false);
      }, 2000);
    }
  }

  return (
    <Button size={size} onClick={handleClick}>
      <IconWrapper>
        <motion.i
          className={`${solidIcon ? "fas" : "far"} fa-clone`}
          initial="unsaved"
          variants={variants}
          animate={animationState}
          whileTap={{ scale: 0.9 }}
          style={{ paddingLeft: "1px" }}
        ></motion.i>
      </IconWrapper>

      <ConfirmationText>
        <AnimatePresence>
          {isSaved ? <RevealingText text="Copied!" /> : null}
          {isError ? <RevealingText text="Try again!" /> : null}
        </AnimatePresence>
      </ConfirmationText>

      {showUno ? <JumpingUno setShowUno={setShowUno} /> : null}
    </Button>
  );
}

function JumpingUno({ setShowUno }) {
  return (
    <motion.div
      initial={{ top: 0 }}
      animate={{
        top: [0, -36, -2],
      }}
      transition={{ duration: 1.5 }}
      style={{ position: "absolute", top: 0, left: 0, zIndex: 5 }}
      onAnimationComplete={() => {
        setShowUno(false);
      }}
    >
      <motion.div
        initial={{
          rotate: -45,
        }}
        animate={{
          rotate: 540,
        }}
        transition={{ duration: 1.5 }}
      >
        <UnoSolid size={16} color="#eceff0" />
      </motion.div>
    </motion.div>
  );
}

function RevealingText({ text }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 1 }}
      animate={{
        opacity: 1,
        scale: 1,
      }}
      exit={{ opacity: 0, scale: 0.5 }}
      transition={{ duration: 0.2 }}
      style={{ fontSize: "12px", marginTop: "2px" }}
    >
      {text}
    </motion.div>
  );
}

const Button = styled.button`
  position: relative;
  background: transparent;
  border: none;
  padding: 0;
  font-size: ${(props) => props.size || "inherit"};
  color: ${(props) => props.color || "inherit"};

  &:hover {
    cursor: pointer;
  }
`;

const IconWrapper = styled(motion.span)`
  position: relative;
  display: grid;
  place-items: center;
  height: 16px;
  height: fit-content;
  /* background-color: white; */
  background-color: #4b647c;
  z-index: 10;
`;

const ConfirmationText = styled(motion.div)`
  position: absolute;
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  font-size: 14px;
`;
